"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.month = void 0;
const chrono_1 = require("../chrono");
const monthConstant = (month) => (context) => {
    context.pushMonth(month);
};
const w_toNumber = (context) => {
    context.pushNumber(context.popMonth() + 1);
};
exports.month = [
    // Constants.
    ["january", monthConstant(chrono_1.Month.January)],
    ["february", monthConstant(chrono_1.Month.February)],
    ["march", monthConstant(chrono_1.Month.March)],
    ["april", monthConstant(chrono_1.Month.April)],
    ["may", monthConstant(chrono_1.Month.May)],
    ["june", monthConstant(chrono_1.Month.June)],
    ["july", monthConstant(chrono_1.Month.July)],
    ["august", monthConstant(chrono_1.Month.August)],
    ["september", monthConstant(chrono_1.Month.September)],
    ["october", monthConstant(chrono_1.Month.October)],
    ["november", monthConstant(chrono_1.Month.November)],
    ["december", monthConstant(chrono_1.Month.December)],
    // Conversions.
    ["month:>number", w_toNumber],
];
